export default __webpack_public_path__ + "static/bottom-man-03d2a8bbe5eb85eeb6e9a5089f3817df.png";